import React, { useState, useEffect, useContext } from "react";
import { Box, Typography, IconButton, Tooltip, useTheme } from "@mui/material";
import "../../assets/menu.css";
import AlbumOutlinedIcon from "@mui/icons-material/AlbumOutlined";
import LogoutButton from "../LogoutButton";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";

export const Profile = React.forwardRef(({ isCollapse = false }, ref) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const { userInfo } = useContext(AuthContext);

  // Determine if we're in women's section based on URL
  const [isWomens, setIsWomens] = useState(
    location.pathname.includes("/womens")
  );

  // Handle toggle change
  const handleToggleChange = () => {
    const newIsWomens = !isWomens;
    setIsWomens(newIsWomens);

    // Navigate to the appropriate route
    if (newIsWomens) {
      navigate("/womens/home");
    } else {
      navigate("/");
    }
  };

  // Update toggle state if URL changes externally
  useEffect(() => {
    setIsWomens(location.pathname.includes("/womens"));
  }, [location.pathname]);

  return (
    <Box>
      {isCollapse ? (
        ""
      ) : (
        <>
          {/* Gender Toggle Switch - Now positioned first */}
          <Box className="side-menu-toggle-container">
            <div
              className={`side-menu-toggle-label ${
                !isWomens ? "active" : "inactive"
              }`}
            >
              Men's
            </div>
            <div
              className={`side-menu-toggle-wrapper ${isWomens ? "womens" : ""}`}
              onClick={handleToggleChange}
            >
              <div className="side-menu-toggle-slider"></div>
            </div>
            <div
              className={`side-menu-toggle-label ${
                isWomens ? "active" : "inactive"
              }`}
            >
              Women's
            </div>
          </Box>

          <Box
            className="user-prof-container"
            display={"flex"}
            flexDirection="column"
            alignItems="center"
          >
            <Box className="user-prof-info">
              <Typography className="user-prof-email" variant="body1">
                {userInfo ? userInfo.email : ""}
              </Typography>
            </Box>
            <Box className="user-prof-logout-container">
              <LogoutButton className="user-prof-logout" />
            </Box>
          </Box>
        </>
      )}
    </Box>
  );
});
